module.exports = __webpack_public_path__ + "static/media/close.e831bf91.svg";